import React from 'react';
import { Link } from 'react-router-dom';

import * as ROUTES from '../../constants/routes';

const Landing = () => (
  <div>
    <div id="bg-blur" class="full-screen-span center-span">
      <div class="center-div">
        <h1>Welcome to Bonsai</h1>
        <p>
          Wind down, treat yourself with some self-love and nature
        </p>
        <div class="button-row">
          <Link to={ROUTES.SIGN_IN}>
            <button class="green-button">Log In</button>
          </Link>
          <Link to={ROUTES.SIGN_UP}>
            <button class="green-button" href="/">
              Sign Up
            </button>
          </Link>
        </div>
      </div>
    </div>
    <div class="full-screen-span">
      <div class="two-columns-grid">
        <div class="left-side center-span">
          <img src="images/unknown.png"></img>
        </div>
        <div class="right-side center-span">
          <div class="hero-right-side">
            <h1>Takecare, Watering & Pruning</h1>
            <p>your bonsai tree</p>
            <button class="green-button" href="/">
              Activities
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="activities-portal full-screen-span">
      <div class="two-columns-grid">
        <div>
          <img src="images/bonsai-lofi.png"></img>
        </div>
        <div>
          <div class="week-calendar">
            <ul>
              <li>mon</li>
              <li>tue</li>
              <li>wed</li>
              <li>thu</li>
              <li>fri</li>
              <li>sat</li>
              <li>sun</li>
            </ul>
            <p>excercise daily to boost your streak</p>
          </div>
          <div class="apps">
            <div>
              <button class="green-button">jotting</button>
              <p>
                releasing your thoughts with jotting will help to
                water the tree. a powerful medicine for many common
                mental health challenges. Regular exercise can have a
                profoundly positive impact on depression, anxiety, and
                ADHD. It also relieves stress, improves memory, helps
                you sleep better, and boosts your overall mood.
                (HelpGuide.org)
              </p>
            </div>
            <div>
              <button class="green-button">pruning</button>
              <p>
                an excercise in meditation and practice in patience
                will teach you taking of yourself. keeping your tree
                health is keeping yourself healthy.
              </p>
            </div>
            <div>
              <button class="green-button">meditating</button>
              <p>
                A study led by Katherine MacLean of the University of
                California suggested that during and after meditation
                training, subjects were more skilled at keeping focus,
                especially on repetitive and boring tasks.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Landing;
